import { memo } from 'react'
import { Box as LabraBox } from '@labrav/react-components'
import { useStyles } from './Installments.styles'
import clsx from 'clsx'
import { InstallmentInfo } from '../../../modules/cppoResellerAgreement/reducer'
import { formatCurrency, fullMonthYear } from '@labrav/common'
import { DateTime } from 'luxon'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useSelector } from '../../../store'

export const Installments = memo(() => {
  const { classes } = useStyles()
  const isMobile = useMediaQuery('(max-width:600px)')
  const { installmentInfo } = useSelector<{
    installmentInfo?: InstallmentInfo[]
  }>(({ cppoResellerAgreement }) => ({
    installmentInfo: cppoResellerAgreement.installmentInfo,
  }))

  if (!installmentInfo || !installmentInfo.length) {
    return <div></div>
  }

  return (
    <div className={classes.root}>
      <LabraBox heading={'Installments'} subHeading={''}>
        <div className={classes.installmentsContainer}>
          <div
            className={clsx(
              classes.installmentsRow,
              classes.installmentsHeader
            )}
          >
            <div>{!isMobile && <span>INSTALLMENT </span>}DATE</div>
            <div>{!isMobile && <span>INSTALLMENT </span>}AMOUNT</div>
          </div>
          {installmentInfo.map((installment, index) => (
            <div key={index} className={classes.installmentsRow}>
              <div>
                {DateTime.fromISO(installment.paymentDate).toFormat(
                  fullMonthYear
                )}
              </div>
              <div>
                {formatCurrency(installment.amount, {
                  currency: installment.currency,
                })}
              </div>
            </div>
          ))}
        </div>
      </LabraBox>
    </div>
  )
})
